import React from 'react'
import Loader from '../../loaders'
import { getEula } from '../../../helpers/restHelpers'

class Component extends React.Component {
    state = {
        loading: true,
    }

    componentDidMount() {
        this.setState({ loading: true })
        getEula()
            .then((response) => this.setState({ ...response }))
            .catch((error) => window.showDialog(error))
            .finally(() => this.setState({ loading: false }))
    }

    render() {
        if (this.state.loading) return <Loader />

        return (
            <div
                style={{
                    padding: 20,
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <div dangerouslySetInnerHTML={{ __html: this.state.text }} />
            </div>
        )
    }
}

export default Component
